//Global clipboard Copier for Custom HTML Buttons
document.addEventListener('click', function() {
    const shareBtn = event.target.closest('[data-share-url]');
    if(!shareBtn) return;

    const pageUrl = shareBtn.getAttribute('data-share-url');
    const textLabel = shareBtn.querySelector('.wg__share-text');
    const defaultIcon = shareBtn.querySelector('wg__share-icon');
    const successIcon = shareBtn.querySelector('wg__success-icon');

    navigator.clipboard.writeText(pageUrl).then(() => {
        if(textLabel) textLabel.textContent = 'COPIED!';
        if(defaultIcon) defaultIcon.style.display = 'none';
        if(successIcon) successIcon.style.display = 'inline-block';
        shareBtn.classList.add('copied');

        setTimeout(() => {
            if(textLabel) textLabel.textContent = 'SHARE';
            if(defaultIcon) defaultIcon.style.display = 'inline-block';
            if(successIcon) successIcon.style.display = 'none';
            shareBtn.classList.remove('copied');
        }, 2500);
    }).catch(err => console.error('Copy failed', err));
});